import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import AgeGate from './components/AgeGate';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Video from './pages/Video';
import Search from './pages/Search';
import Categories from './pages/Categories';
import Trending from './pages/Trending';
import Watchlist from './pages/Watchlist';
import Favorites from './pages/Favorites';
import History from './pages/History';
import Subscription from './pages/Subscription';
import Messages from './pages/Messages';
import CreatorDashboard from './pages/CreatorDashboard';
import CreatorProfile from './pages/CreatorProfile';
import Creators from './pages/Creators';
import BecomeModel from './pages/BecomeModel';
import OrientationPage from './pages/OrientationPage';
import Referral from './pages/Referral';
import AdNetworkSetup from './pages/AdNetworkSetup';
import LiveStreams from './pages/LiveStreams';
import LiveStream from './pages/LiveStream';
import AIImageGenerator from './pages/AIImageGenerator';
import './App.css';

function App() {
  const [ageVerified, setAgeVerified] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('age_verified');
    if (verified === 'true') {
      setAgeVerified(true);
    }
  }, []);

  const handleAgeVerified = () => {
    setAgeVerified(true);
  };

  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="app-container" data-testid="app-container">
            {!ageVerified && (
              <AgeGate onVerified={handleAgeVerified} />
            )}

            {ageVerified && (
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/video/:id" element={<Video />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/trending" element={<Trending />} />
                  <Route path="/watchlist" element={<Watchlist />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/subscription" element={<Subscription />} />
                  <Route path="/subscription/success" element={<Subscription />} />
                  <Route path="/messages" element={<Messages />} />
                  <Route path="/messages/:recipientId" element={<Messages />} />
                  <Route path="/creator-studio" element={<CreatorDashboard />} />
                  <Route path="/creator/:userId" element={<CreatorProfile />} />
                  <Route path="/creators" element={<Creators />} />
                  <Route path="/become-model" element={<BecomeModel />} />
                  <Route path="/browse/:type" element={<OrientationPage />} />
                  <Route path="/referral" element={<Referral />} />
                  <Route path="/admin/ad-setup" element={<AdNetworkSetup />} />
                  <Route path="/live" element={<LiveStreams />} />
                  <Route path="/live/:streamId" element={<LiveStream />} />
                  <Route path="/ai-generator" element={<AIImageGenerator />} />
                </Routes>
              </>
            )}

            <Toaster 
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#1A1A1A',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff',
                },
              }}
            />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
